import React from "react";
import PropTypes from "prop-types";
import * as L from 'leaflet';
import  debounce from 'lodash/debounce';
import 'leaflet/dist/leaflet.css'
import 'leaflet-geosearch/assets/css/leaflet.css';
import { SearchBox } from 'leaflet-searchbox'
import 'leaflet-searchbox/dist/style.css'

class WreckMap extends React.Component {
  constructor(props) {
  	super(props);
  	this.state = { location: {}, data:{} };
    this.setUpMap = this.setUpMap.bind(this);
    this.getPositionAndSetupMap();
  };

  componentDidMount() {
    if(this.props.maptype=='map' || this.props.maptype=='bath') {
    } else if (this.props.maptype=='chart') {
      const script = document.createElement("script");
      script.src = "https://webapiv2.navionics.com/dist/webapi/webapi.min.no-dep.js";
      script.async = true;
      script.onload = () => this.setUpMap()
      document.body.appendChild(script);
    }
  }

  componentDidUpdate() {
    //window.addEventListener('DOMContentLoaded', this.setUpMap());
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.state.data != nextState.data) {
      return false;
    }
    return true;
  }

  async getPositionAndSetupMap() {
    try {
      const position = await this.getCurrentPosition()
      this.setUpMap(position.coords.latitude, position.coords.longitude);
    } catch (err) {
      this.setUpMap(51.5, 0);
    }
  }

  getCurrentPosition() {
    return new Promise( (resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        position => resolve(position),
        error => reject(error)
      )
    })
  }

  setLocation(lat, long) {
    this.setState({location: {latitude: lat, longitude: long}});
  }
 
  setUpMap(lat, long){
    var myMap = L.map('mapid');
    var myIcon = L.icon({});

    if(this.props.maptype=='map') {
      L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: 'mapbox/streets-v11',
          tileSize: 512,
          zoomOffset: -1,
          accessToken: this.props.token
      }).addTo(myMap);
    } else if (this.props.maptype=='bath') {
      L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: 'spencermeyer/cl4bf4gv2000f15t9lxjc7lwz',
          tileSize: 512,
          zoomOffset: -1,
          accessToken: this.props.token
      }).addTo(myMap);
    }
    else if (this.props.maptype=='chart') {
      var overlay = new window.JNC.Leaflet.NavionicsOverlay({
          navKey: 'Navionics_webapi_03898',
          chartType: JNC.NAVIONICS_CHARTS.NAUTICAL,
          isTransparent: false,
          zIndex: 1,
          maxZoom: 18
      });
      overlay.addTo(myMap);
    }

    var control = new L.Control.SearchBox({});
    myMap.addControl(control);

    myMap.setView([this.props.latitude || lat || 51.5, this.props.longitude || long || 0], 13);
    // myMap.locate;
    var position = myMap.getCenter();
    var zoomLevel = myMap.getZoom();

    var layerGroup = L.layerGroup().addTo(myMap);

    addMarkers(finished);
  
    function addMarkers(callback) {
      layerGroup.clearLayers();
      myMap.closePopup();
      var wreckMarker = L.icon({ iconUrl: 'marker_new.svg',
                                  iconSize: [50, 50],
                                  iconAnchor: [25, 25]
                                });

      var zoomLevel = myMap.getZoom();
      var position = myMap.getCenter();
      $.ajax({ 
        url: `/wrecks.json?zoom=${zoomLevel}&lat=${position['lat']}&long=${position['lng']}`,
        success: (data) => {
          $.each(data, function(i, elem) {
            L.marker([elem['latitude'], elem['longitude']], {icon: wreckMarker})
              .addTo(layerGroup)
              .on('click', function(){ 
                window.location.href=`/wrecks/${elem['id']}`
               })
              .bindTooltip(elem['title'], {autoPan:false}).openPopup();
          });
        }
      });
      callback();
    }

    function reWriteHistory (lat, long) {
      if (window.location.pathname.includes('chart') || window.location.pathname.includes('map')) {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('latitude', lat);
        urlParams.set('longitude', long);
        window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);        
      }
    }

    function finished(){
    }

    myMap.on('zoomend', function() {
      if (this.getZoom() > 13) {
        $('#zoom-warning').addClass('hidden')
      } else if (this.getZoom() < 13) {
        $('#zoom-warning').removeClass('hidden')
      }
      debouncedAddMarkers(finished);
    })

    var debouncedAddMarkers = debounce(addMarkers, 500, {});

    myMap.on('moveend', function(){
      debouncedAddMarkers(finished);
      reWriteHistory(this.getCenter().lat, this.getCenter().lng);
    })
  }

  render () {
    return (
      <div>
        <div id='mapid'>
        </div>
        <div id='zoom-warning' className='zoom-warning alert alert-warning'>
          <span className="emphasize">At this zoom level, not all wrecks are shown because there are too many</span><br></br>
            Zoom in to see all the wrecks in your area of interest.
        </div>
      </div>
    );
  }
}

export default WreckMap;
